import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { RootState } from 'app/app.module';
import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {LocalStorageService} from "../local-storage.service";


@Injectable({
	providedIn: 'root',
})
export class ReportsService {
	constructor(
		public route: ActivatedRoute,
		private router: Router,
		private store: Store<RootState>,
		private localStorageService: LocalStorageService
	) {}

	handleToggle(event) {
		this.handleParamsChange({ chartVisible: event || null }, null);
	}

	handleFilterUpdate(event, action = null) {
		const newParams = {};
		_.forEach(event, (val) => {
			if (!newParams[val.value.name]) {
				newParams[val.value.name] = [val.value.code];
			} else {
				newParams[val.value.name].push(val.value.code);
			}
		});
		this.handleParamsChange(newParams, action);
	}

	handleDateChange(event, action = null) {
		this.router.navigate([], {
			queryParams: event,
			queryParamsHandling: 'merge',
		}).then(() => {
			if (action) {
				this.store.dispatch(action);
			}
		});
	}

	handleParamsChange(event, action = null) {
		this.router.navigate([], {
			queryParams: event,
			queryParamsHandling: 'merge',
		}).then(() => {
			if (action) {
				this.store.dispatch(action);
			}
		});
	}

	clearFilters(action = null) {
		this.router.navigate([], {
			queryParams: null,
		}).then(() => {
			if (action) {
				this.store.dispatch(action);
			}
		});
	}

	routeToELDx(eldxRoute: string){
		let account = this.localStorageService.get('activeAccount');
		let params = this.router.url.split('?');
		let qParams = `activeAccount=${account}`;
		if (params.length > 1) {
			qParams = `${qParams}&${params[1]}`;
		}
		window.location.href = `${environment.urls.eldx}/${eldxRoute}?${qParams}`
	}
}
